/// <reference path="../../../app.definition.ts" />

import angular from "angular";
export class ShareableLinkController {
  category: string;
  itemId: number;
  password: string;
  showLoader: boolean;
  signedCopy: boolean;
  signedUrl: string;
  unSignedUrl: string;
  signCopyExists: boolean;

  static $inject = ["$uibModalInstance", "category", "itemId", "signCopyExists", "postType", "ApiAdapterService", "CacheService"];
  constructor($uibModalInstance, category, itemId, signCopyExists, postType, ApiAdapterService, CacheService) {
    var shareableLinkVm: any = this;

    shareableLinkVm.category = category;
    shareableLinkVm.url = "";
    shareableLinkVm.postType = postType;
    shareableLinkVm.copyTooltipText = "Copy to clipboard";
    shareableLinkVm.copyTooltip = angular.copy(shareableLinkVm.copyTooltipText);
    shareableLinkVm.password = CacheService.getPassword();
    if (signCopyExists) {
      shareableLinkVm.signedCopyExists = true;
      shareableLinkVm.signedCopy = true;
    } else {
      shareableLinkVm.signedCopy = false;
      shareableLinkVm.signCopyExists = false;
    }



    shareableLinkVm.close = () => {
      $uibModalInstance.dismiss();
    }

    shareableLinkVm.copySuccessCallback = () => {
      toastr.success('Link successfully copied to clipboard');
    }

    shareableLinkVm.getShareableLink = () => {

      if (shareableLinkVm.signedCopy && shareableLinkVm.signedUrl != null) {
        shareableLinkVm.url = shareableLinkVm.signedUrl;
      } else if (!shareableLinkVm.signedCopy && shareableLinkVm.unSignedUrl != null) {
        shareableLinkVm.url = shareableLinkVm.unSignedUrl;
      } else {
        shareableLinkVm.showLoader = true;
        ApiAdapterService.getShareableLink(itemId, category.toLowerCase(), shareableLinkVm.password, shareableLinkVm.signedCopy, shareableLinkVm.postType).then((s) => {
          shareableLinkVm.showLoader = false;
          shareableLinkVm.url = s.shareableLink;
          if (shareableLinkVm.signedCopy) {
            shareableLinkVm.signedUrl = s.shareableLink;
          } else {
            shareableLinkVm.unSignedUrl = s.shareableLink;
          }
        }, (e) => {
          shareableLinkVm.showLoader = false;
          console.log(e);
        })
      }
    }

    shareableLinkVm.getShareableLink();
  }
}


angular.module('eCareVault.common.popUp')
  .controller('ShareableLinkController', ShareableLinkController);
